/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Marketing_Title_1Inputs */

const en_wb_marketing_title_1 = /** @type {(inputs: Wb_Marketing_Title_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The numbers are gathered.`)
};

const lv_wb_marketing_title_1 = /** @type {(inputs: Wb_Marketing_Title_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skaitļi ir savākti.`)
};

/**
* | output |
* | --- |
* | "The numbers are gathered." |
*
* @param {Wb_Marketing_Title_1Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_marketing_title_1 = /** @type {((inputs?: Wb_Marketing_Title_1Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Marketing_Title_1Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_marketing_title_1(inputs)
	return en_wb_marketing_title_1(inputs)
});